import EarlyAccess from '../../src/legacy/EarlyAccess';
export default EarlyAccess;
